module.exports = {
  date: {
    type: 'date-picker',
    placeholder: 'request-call.date-placeholder',
    validation: [
      { type: 'required' },
    ],
  },
  hourRange: {
    type: 'select',
    isOptionsLocalized: true,
    placeholder: 'request-call.hour-range-placeholder',
    validation: [
      { type: 'required' },
    ],
  },
  note: {
    type: 'textarea',
    placeholder: 'request-call.note-placeholder',
  },
  mobilePhone: {
    type: 'text',
    placeholder: 'request-call.mobile-placeholder',
    validation: [
      { type: 'required' },
    ],
  },
  email: {
    type: 'text',
    placeholder: 'request-call.email-placeholder',
    validation: [
      { type: 'required' },
    ],
  },
};
